import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    // 홈. Figma 252:2916 기준, 스토리보드 홈1-1~홈1-48 의 스크롤 인터랙션이 들어 있다.
    { path: '/', name: 'home', component: HomeView },
    // IR. 공통 헤더 메뉴의 B2B 가 여기로 온다.
    // Figma SPy784gVofOiWCNGp8XWhp / 2032:314 (2026-09-24 새 프레임으로 교체).
    { path: '/b2b', name: 'b2b', component: () => import('@/views/IrView.vue') },
    // 교체 전 화면(Figma 307:6074). 새 화면에 문제가 생기면 여기서 비교한다.
    // 안정되면 걷어낸다 — 예전 홈을 /legacy 에 남겨 둔 것과 같다.
    { path: '/b2b/v1', name: 'b2b-v1', component: () => import('@/views/IrV1View.vue') },
    // 잠깐 쓰던 주소들. 열어 둔 탭이 흰 화면이 되지 않게 넘겨 준다.
    //   /b2b/v2  비교용으로 쓰던 주소
    //   /b2b2    새 퍼블리싱 작업대. 2026-09-24 에 /b2b 로 올렸다.
    // 한동안 두었다가 걷어내면 된다.
    { path: '/b2b/v2', redirect: { name: 'b2b' } },
    { path: '/b2b2', redirect: { name: 'b2b' } },
    // 작업대였던 주소. 2026-09-22 에 / 로 올렸다. 열어 둔 탭이 흰 화면이 되지 않게 넘겨 준다.
    { path: '/home2', redirect: { name: 'home' } },
    // 글자 기준을 1920 으로 옮겨 본 비교용 주소였다. 2026-09-25 에 / 로 올렸다.
    // 열어 둔 탭이 흰 화면이 되지 않게 넘겨 준다.
    { path: '/home3', redirect: { name: 'home' } },
    // 직영점(상단 메뉴 이름은 지점소개). Figma 8241:6115 (2026-10-06).
    // 상단 메뉴 여섯 번째(마지막) 칸이 여기로 온다.
    { path: '/branch', name: 'branch', component: () => import('@/views/BranchView.vue') },
    // REAL GOLD TRADE 안쪽 두 화면. 상단 메뉴 'REAL GOLD TRADE' 를 누르면 펼쳐지는
    // 작은 메뉴(소개 · 오늘의 시세)가 여기로 온다(Figma 8236:23710, 공용 SiteHeader).
    //   소개          Figma 8241:3981  (2026-10-06)
    //   오늘의 시세   Figma 8241:5170  (2026-10-06)
    { path: '/trade/intro', name: 'trade-intro', component: () => import('@/views/IntroView.vue') },
    { path: '/trade/rates', name: 'trade-rates', component: () => import('@/views/RatesView.vue') },
    // 예전 홈(칸 점프 방식). 새 홈에 문제가 생기면 여기서 비교한다.
    // 자사몰·미디어허브도 같은 이름을 쓴다. 안정되면 걷어낸다.
    { path: '/legacy', name: 'home-legacy', component: () => import('@/views/HomeDesktopView.vue') },
  ],
})

export default router
